import wretch from 'wretch';
import QueryStringAddon from 'wretch/addons/queryString';

export default (baseURL?: string) => wretch(baseURL).addon(QueryStringAddon);
